import { compareDates, formatDate } from '../common/formatDate';
import { DATE_FORMAT_ISO_FNS } from '../constants/dateFormats';

export function makeNoLaterThenValidator<T>(
  errorMsg: T,
  getMaxDate: () => string | undefined,
  canBeEqual: boolean = true,
) {
  return (value: string) => {
    const maxDate = getMaxDate();

    if (!maxDate) {
      return undefined;
    }

    const compareResult = compareDates({
      dateLeft: formatDate({ date: value, dateFormat: DATE_FORMAT_ISO_FNS }),
      dateRight: formatDate({ date: maxDate, dateFormat: DATE_FORMAT_ISO_FNS }),
    });

    if (compareResult === 1 || (!canBeEqual && compareResult === 0)) {
      return errorMsg;
    }

    return undefined;
  };
}
